import DoctorForm from './Forms/DoctorForm';
import FacilityForm from './Forms/FacilityForm';
import './ProviderRegistration.scss';
import { ToastContainer } from 'react-toastify';

const ProviderInformation = ({
  providerType,
  nextStep,
  facilityFieldList,
  PhysicianFieldList,
  userData,
  formData,
  handleInput,
  schema,
  PhysicianValues,
  facilityUserData,
  facilityFormData,
  handleFacilityInput,
  validateProviderFacility,
  facilityValues,
}) => {
  console.log('facilityValues', facilityValues);
  return (
    <div className="">
      <p className="pt-2">{`${providerType} Information`}</p>
      {providerType === 'Doctor' ? (
        <DoctorForm
          PhysicianFieldList={PhysicianFieldList}
          userData={userData}
          formData={formData}
          handleInput={handleInput}
          schema={schema}
          validateProviderFacility={validateProviderFacility}
          PhysicianValues={PhysicianValues}
        />
      ) : (
        <FacilityForm
          facilityFieldList={facilityFieldList}
          facilityUserData={facilityUserData}
          facilityFormData={facilityFormData}
          handleFacilityInput={handleFacilityInput}
          validateProviderFacility={validateProviderFacility}
          facilityValues={facilityValues}
        />
      )}
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

export default ProviderInformation;
